module.exports = __webpack_public_path__ + "static/media/tloczenie.a12d88e9.svg";